<template>
  <div class="text-whitebase">
    <div class="w-full h-14 relative">
      <div class="relative z-10 flex justify-between py-2 px-4">
        <div class="flex items-center">
          <UiImg
            class="w-10 h-10 rounded-lg flex-shrink-0"
            :src="state.selectedItem.imageUrl"
          ></UiImg>
          <div class="mx-2 line-clamp-1 text-sm font-bold">
            {{ state.selectedItem.name }}
          </div>
        </div>
        <button @click="store.commit('toggleBackdrop', false)">
          <span class="icon iconfont">&#xe610;</span>
        </button>
      </div>
      <div
        class="absolute inset-0 overflow-hidden pb-4 bg-white z-0"
        style="height: 56px"
      >
        <img
          class="w-full"
          :src="
            state.selectedItem.imageUrl ||
            require('@/assets/icons/nftnologo.avif')
          "
          alt=""
        />
        <div
          class="w-full h-full absolute top-0 left-0 bg-white opacity-40"
        ></div>
        <div
          class="
            backdrop-filter backdrop-blur-xl
            w-full
            h-full
            absolute
            top-0
            left-0
          "
        ></div>
      </div>
    </div>

    <div>
      <div class="px-4 pt-6" v-if="loadingx || state.nftInfo.type">
        <div class="flex justify-center w-full" v-if="loadingx">
          <div>
            <Spin class="mx-auto"></Spin>
          </div>
        </div>
        <div v-else>
          <div class="font-bold text-xl">
            {{
              state.nftInfo.type == 'Artwork'
                ? 'Artist'
                : state.nftInfo.type == '1155'
                ? 'Belong'
                : 'Collection'
            }}
          </div>

          <div class="mt-4" style="border-bottom: 1px solid #ffffff1a">
            <UiImg
              class="w-14 h-14 rounded-full mr-4 flex-shrink-0 self-start"
              :src="state.nftInfo.logo"
            ></UiImg>

            <div class="flex">
              <div class="font-bold line-clamp-1 flex-1" style="height: 24px">
                {{ state.nftInfo.name }}
              </div>
              <div class="flex items-center ml-4 space-x-2">
                <div
                  v-if="state.nftInfo.address"
                  class="
                    h-6
                    px-4
                    rounded
                    flex
                    items-center
                    justify-center
                    text-xs
                    cursor-pointer
                  "
                  style="background: #ffffff1a"
                  @click="
                    toExploreAddress(
                      state.nftInfo.address,
                      BackNetworkType[state.nftInfo.chain],
                    )
                  "
                >
                  {{ formatAddress(state.nftInfo.address, 3) }}
                </div>

                <a
                  class="block flex-shrink-0"
                  :href="state.nftInfo.website"
                  v-if="state.nftInfo.website"
                  target="_blank"
                >
                  <div class="hover:bg-[#FFFFFF1A] rounded">
                    <img
                      class="w-4 h-4 cursor-pointer"
                      src="@/assets/icons/i-website.avif"
                      alt=""
                    />
                  </div>
                </a>

                <a
                  class="block flex-shrink-0"
                  :href="`https://twitter.com/${state.nftInfo.twitter}`"
                  target="_blank"
                  v-if="state.nftInfo.twitter"
                >
                  <div class="hover:bg-[#FFFFFF1A] rounded">
                    <img
                      class="w-4 h-4 cursor-pointer"
                      src="@/assets/icons/i-twitter.avif"
                      alt=""
                    />
                  </div>
                </a>
              </div>
            </div>

            <SeeMoreText
              class="text-xs mt-2 text-white-070 flex-1"
              :text="state.nftInfo.desc || ''"
            >
            </SeeMoreText>

            <div class="flex flex-wrap my-6 text-xs justify-between">
              <div
                class="flex flex-col items-start"
                style="width: 114px; height: 42px"
              >
                <div class="font-bold">{{ state.nftInfo.param1 }}</div>
                <div class="text-gray-level">
                  {{ state.nftInfo.type == 'Artwork' ? 'Artworks' : 'Items' }}
                </div>
              </div>
              <div
                class="flex flex-col items-start"
                style="width: 114px; height: 42px"
              >
                <div class="font-bold">
                  <UnitText unit="ETH" iconClass="text-xs">
                    {{ localeNumber(state.nftInfo.param2, 2) }}
                  </UnitText>
                </div>
                <div class="text-gray-level">
                  {{
                    state.nftInfo.type == 'Artwork'
                      ? 'Historical Value'
                      : 'Total volume'
                  }}
                </div>
              </div>
              <div
                class="flex flex-col items-start"
                style="width: 114px; height: 42px"
              >
                <div class="font-bold">
                  <UnitText unit="ETH" iconClass="text-xs">{{
                    localeNumber(state.nftInfo.param3, 2)
                  }}</UnitText>
                </div>
                <div class="text-gray-level">
                  {{
                    state.nftInfo.type == 'Artwork'
                      ? 'Market cap'
                      : state.nftInfo.type == '1155'
                      ? 'lastest price'
                      : 'Floor price'
                  }}
                </div>
              </div>
              <div
                class="flex flex-col items-start"
                style="width: 114px; height: 42px"
              >
                <div class="font-bold">
                  <UnitText
                    unit="ETH"
                    iconClass="text-xs"
                    v-if="state.nftInfo.type == 'Artwork'"
                  >
                    {{ state.nftInfo.param4 }}
                  </UnitText>
                  <span v-else>{{ state.nftInfo.param4 }}</span>
                </div>
                <div class="text-gray-level">
                  {{
                    state.nftInfo.type == 'Artwork'
                      ? 'Evaluation'
                      : 'Collectors'
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="px-4 py-6 mb-6 text-sm" :class="{ hidden: state.hidden }">
        <div class="pb-2 mb-6" style="border-bottom: 1px solid #ffffff1a">
          <div class="flex items-center">
            <UiImg
              class="w-10 h-10 rounded-lg flex-shrink-0"
              :src="state.selectedItem.imageUrl"
            ></UiImg>
            <div class="mx-2 line-clamp-1">
              {{ state.selectedItem.name }}
            </div>
            <UiImg
              class="w-6 h-6 cursor-pointer flex-shrink-0"
              :src="
                state.selectedItem.network == 'tezos'
                  ? require('@/assets/linkicon/objkt.avif')
                  : require('@/assets/linkicon/opensea.avif')
              "
              @click="
                jumpTokenId(
                  state.selectedItem.tokenId,
                  state.selectedItem.network,
                  state.selectedItem.contractAddress,
                )
              "
            ></UiImg>
          </div>

          <div class="flex mt-4 justify-between">
            <div>
              Owner:
              <span
                v-if="state.selectedItem.ownerAddressList"
                class="text-secondary-7 underline cursor-pointer"
                @click="
                  toExploreAddress(
                    state.selectedItem.ownerAddressList[0].address,
                    BackNetworkType[state.selectedItem.network],
                  )
                "
              >
                {{
                  formatAddress(
                    state.selectedItem.ownerAddressList[0].address,
                    4,
                  )
                }}
              </span>
            </div>

            <div
              v-if="state.nftInfo.blockTimestamp"
              class="text-secondary-7 cursor-pointer"
              @click="
                toExploreAddress(
                  state.nftInfo.transactionHash,
                  BackNetworkType[state.selectedItem.network],
                  'tx',
                )
              "
            >
              Received
              {{ formatDateText(state.nftInfo.blockTimestamp) }}
            </div>
          </div>
        </div>

        <div class="space-y-2">
          <div class="">Valuation</div>

          <!--  -->
          <div class="flex">
            Estimated Price:
            <EthText
              class="ml-2"
              :class="{
                'cursor-pointer hover:underline hover:text-secondary-7':
                  state.nftInfo.path,
              }"
              @click="jump(state.nftInfo.path)"
            >
              <div v-if="isFloor && !+state.selectedItem.floorPrice">N/A</div>

              <ValueCell v-else :isUsdt="isUsdt" class="text-right">
                {{
                  localeNumber(
                    isUsdt
                      ? isFloor
                        ? state.selectedItem.floorPriceUsd
                        : state.selectedItem.lastPriceUsd
                      : isFloor
                      ? state.selectedItem.floorPrice
                      : state.selectedItem.lastPrice,
                    2,
                  )
                }}
              </ValueCell>
            </EthText>
          </div>

          <!-- <div class="text-xs" v-if="state.nftInfo.trait">
                <span class="text-gray-level">(The most CORE TRAITS)</span>
                <i class="iconfont icon-tishi ml-2" iconClass="text-xs"></i>
              </div> -->

          <div class="flex">
            Lastest Price:
            <UnitText
              @click="
                state.nftInfo.txHash &&
                  toExploreAddress(
                    state.nftInfo.txHash,
                    BackNetworkType[state.nftInfo.chain],
                    'tx',
                  )
              "
              class="ml-2 hover:underline cursor-pointer"
              :unit="state.nftInfo.coinSymbolOfLatestPrice"
              >{{
                state.nftInfo.latestPrice
                  ? formatVal(state.nftInfo.latestPrice, { bit: 2 })
                  : '-'
              }}</UnitText
            >
          </div>

          <div v-if="state.nftInfo.type == 'PFP'">
            {{ `“${state.nftInfo.trait}” price by history` }}
          </div>

          <NftScatter
            v-if="state.nftScatter.length > 0"
            :loading="false"
            :data="state.nftScatter"
            :cutPoint="state.nftCutTime"
          ></NftScatter>
        </div>

        <div class="mt-3">
          <div class="font-bold mb-2">Details</div>
          <div class="flex justify-between mb-2">
            <div class="text-gray-level">Contract Address</div>
            <div
              v-if="state.selectedItem.contractAddress"
              class="text-secondary-7 cursor-pointer"
              @click="
                toExploreAddress(
                  state.selectedItem.contractAddress,
                  BackNetworkType[state.selectedItem.network],
                )
              "
            >
              {{ formatAddress(state.selectedItem.contractAddress, 4) }}
            </div>
          </div>
          <div class="flex justify-between mb-2">
            <div class="text-gray-level">Token ID</div>
            <div class="line-clamp-1 w-52 text-right">
              {{ state.selectedItem.tokenId }}
            </div>
          </div>
          <div class="flex justify-between mb-2">
            <div class="text-gray-level">Token Standard</div>
            <div>{{ state.selectedItem.contractType }}</div>
          </div>
          <div class="flex justify-between mb-2">
            <div class="text-gray-level">Blockchain</div>
            <div>{{ BackNetworkType[state.selectedItem.network] }}</div>
          </div>
          <div class="flex justify-between mb-2">
            <div class="text-gray-level">Metadata</div>
            <tippy :content="state.selectedItem.metadata">
              <div class="text-secondary-7">Metadata</div>
            </tippy>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SeeMoreText from '@/components/SeeMoreText.vue';
import Spin from '@/components/Spin.vue';
import UiImg from '@/components/UiImg.vue';
import { BackNetworkType } from '@/constants';
import {
  formatAddress,
  formatDateText,
  formatVal,
  getNftValuePath,
  jumpTokenId,
  localeNumber,
  toExploreAddress,
} from '@/utils';
import { computed, onMounted } from 'vue';
import NftScatter from './NftScatter.vue';
import ValueCell from './ValueCell.vue';

import UnitText from '@/components/UnitText.vue';
import { useStore } from 'vuex';
const state = computed(() => store.state.nftInfo);
const store = useStore();
console.log('store info', state);

const jump = (path) => {
  if (path) {
    window.open(
      getNftValuePath(path),

      '_blank',
    );
  }
};
onMounted(() => {
  window.scrollTo(0, 0);
});
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  background-color: #fff;
  padding: 20px;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
}
</style>
